var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123,
    height: 122.999,
    viewBox: "0 0 123 122.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.42,
    x2: 0.5,
    y2: 0.582,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c334"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(-335.043 -67.088)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M457.543,128.589a61,61,0,1,1-61-61A61,61,0,0,1,457.543,128.589Z",
    fill: "#e6c334",
    stroke: "#e6c334",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M396.271,185.561a55.189,55.189,0,1,1,55.192-55.189A55.19,55.19,0,0,1,396.271,185.561Z",
    transform: "translate(0.498 0.374)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(358.133 100.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M358.553,107.39a1.709,1.709,0,0,1-1.114-3.01,25.269,25.269,0,0,1,14.06-5.936,1.713,1.713,0,0,1,.307,3.413,21.827,21.827,0,0,0-12.143,5.121A1.7,1.7,0,0,1,358.553,107.39Z",
    transform: "translate(-356.839 -98.44)",
    fill: "#5f380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M429.115,107.39a1.707,1.707,0,0,1-1.113-.411,21.845,21.845,0,0,0-12.145-5.121,1.714,1.714,0,0,1,.309-3.413,25.3,25.3,0,0,1,14.065,5.936,1.711,1.711,0,0,1-1.115,3.01Z",
    transform: "translate(-354.01 -98.44)",
    fill: "#5f380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M423.855,122.4a5.486,5.486,0,1,1-5.483-5.67A5.583,5.583,0,0,1,423.855,122.4Z",
    transform: "translate(-354.08 -97.539)",
    fill: "#5f380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M374.512,122.4a5.484,5.484,0,1,1-5.478-5.67A5.582,5.582,0,0,1,374.512,122.4Z",
    transform: "translate(-356.509 -97.539)",
    fill: "#5f380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81509",
    "data-name": "Path 81509",
    d: "M2.782,0A59.74,59.74,0,0,0,19.768,2.782,75.25,75.25,0,0,0,38.025,0a2.782,2.782,0,0,1,0,5.565A74.682,74.682,0,0,1,19.768,8.37,59.3,59.3,0,0,1,2.782,5.565,2.782,2.782,0,0,1,2.782,0Z",
    transform: "translate(18.933 52.701)",
    fill: "#5f380f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFeedback);
export default __webpack_public_path__ + "static/media/sad-feedback.df44449502d418848780bb4d43c0e9e2.svg";
export { ForwardRef as ReactComponent };